import editImage from "../../../common/images/edit.svg";
import deleteImage from "../../../common/images/delete.svg";
import { PrimaryTableRow } from "@hatch-digital-nl/abs-storybook/legacy";
import { EmployeeScheduledQualificationInterface } from "../../../common/interfaces/ScheduledQualificationInterface";
import { Dispatch } from "redux";
import {
    setIsDeleteScheduledQualificationModalOpen,
    setScheduledQualificationId,
} from "../ScheduledQualificationsSlice";
import { format } from "date-fns";
import {
    setEmployeeScheduledQualification,
    setIsScheduleQualificationModalOpen,
} from "../../../modals/UpsertScheduleQualificationModal/UpsertScheduleQualificationModalSlice";
import { getUserFullName } from "../../../common/utils/getUserFullName";

interface Props {
    employeeScheduledQualifications: EmployeeScheduledQualificationInterface[];
    dispatch: Dispatch;
    isEstablishmentManager?: boolean;
}

export const getTableRows = (props: Props): PrimaryTableRow[][] => {
    const {
        employeeScheduledQualifications,
        dispatch,
        isEstablishmentManager,
    } = props;

    return employeeScheduledQualifications.map(
        (employeeScheduledQualification): PrimaryTableRow[] => {
            const scheduledQualification =
                employeeScheduledQualification.scheduled_qualification;

            return [
                ...(isEstablishmentManager
                    ? [
                          {
                              value:
                                  getUserFullName(
                                      employeeScheduledQualification.employee
                                          .user,
                                  ) ?? "-",
                          },
                      ]
                    : []),
                {
                    value: scheduledQualification.qualification.name,
                },
                {
                    value: scheduledQualification.qualification
                        .qualification_standards?.length
                        ? scheduledQualification.qualification.qualification_standards.map(
                              (qualificationStandard) =>
                                  qualificationStandard.tag,
                          )
                        : "",
                },
                {
                    value: scheduledQualification.educator.name,
                },
                {
                    value: format(
                        scheduledQualification.starts_at,
                        "dd-MM-yyyy",
                    ),
                },
                {
                    value: format(scheduledQualification.ends_at, "dd-MM-yyyy"),
                },
                {
                    value: "",
                    actionData: [
                        {
                            title: "Bewerken",
                            iconUrl: editImage,
                            onClick: () => {
                                dispatch(
                                    setEmployeeScheduledQualification(
                                        employeeScheduledQualification,
                                    ),
                                );
                                dispatch(
                                    setIsScheduleQualificationModalOpen(true),
                                );
                            },
                        },
                        {
                            title: "Verwijderen",
                            iconUrl: deleteImage,
                            onClick: () => {
                                dispatch(
                                    setScheduledQualificationId(
                                        scheduledQualification.id,
                                    ),
                                );
                                dispatch(
                                    setIsDeleteScheduledQualificationModalOpen(
                                        true,
                                    ),
                                );
                            },
                        },
                    ],
                },
            ];
        },
    );
};
